// src/components/SponsoredPostCard.js
import React from 'react';
import './SponsoredPostCard.css';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import storePlaceholder from '../assets/placeholder-logo.png';
import adsIcon from '../assets/ads-icon.png';
import blueTickIcon from '../assets/bluetick-icon.png'; // ✅ NEW

function SponsoredPostCard({ product }) {
  const navigate = useNavigate();
  if (!product) return null;

  const {
    _id,
    name,
    description,
    media,
    storeLogo,
    businessName,
    businessUsername,
  } = product;

  const handleViewerClick = async () => {
    try {
      await api.post(`/interactions/click/${_id}`);
    } catch (err) {
      console.error('❌ Failed to track sponsored viewer click:', err);
    }
  };

  const handleVisitStore = () => {
    if (!businessUsername || typeof businessUsername !== 'string' || businessUsername.trim() === '') {
      console.warn('❌ Cannot navigate — businessUsername is missing or invalid:', businessUsername);
      return;
    }
    navigate(`/store/${businessUsername}`);
  };

  const mediaUrl = media?.[0];
  const isVideo = !!mediaUrl?.endsWith?.('.mp4');

  return (
    <div className="sponsored-post-card">
      {/* Header: store + blue tick (left) + ads icon (far right) */}
      <div className="sponsored-card-header" onClick={handleVisitStore}>
        <div className="sponsored-header-left">
          <img
            src={storeLogo?.trim() ? storeLogo : storePlaceholder}
            alt="Store Logo"
            className="sponsored-store-logo"
          />
          <div className="sponsored-store-info">
            <div className="sponsored-store-row">
              <strong
                className="sponsored-store-name"
                title={`@${businessUsername}`}
              >
                {businessName?.trim() || 'Unnamed Business'}
              </strong>
              <img
                src={blueTickIcon}
                alt="Verified merchant"
                className="sponsored-badge-icon"
              />
            </div>
            <div className="sponsored-label">Sponsored</div>
          </div>
        </div>

        {/* 🔁 Moved to the far right */}
        <img src={adsIcon} alt="Ad" className="sponsored-ads-icon" />
      </div>

      {/* Description (2-line clamp, above image) */}
      {(description?.trim()?.length ?? 0) > 0 ? (
        <p className="sponsored-description-top">{description}</p>
      ) : (
        <p className="sponsored-description-top muted">No description</p>
      )}

      {/* Media (click → track + go to product) */}
      <div
        className="sponsored-media-section"
        onClick={async () => {
          await handleViewerClick();
          navigate(`/product/${_id}`);
        }}
      >
        {isVideo ? (
          <video
            className="sponsored-media"
            src={mediaUrl}
            muted
            loop
            autoPlay
            playsInline
          />
        ) : (
          <img
            src={mediaUrl}
            alt={name || 'Sponsored Product'}
            className="sponsored-media"
          />
        )}
      </div>

      {/* Bottom: Visit Store button */}
      <div className="sponsored-bottom-row">
        <button className="visit-store-button" onClick={handleVisitStore}>
          Visit Store
        </button>
      </div>
    </div>
  );
}

export default SponsoredPostCard;
